import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import SingleNavItem from "./SingleNavItem";
import useOutsideClick from "../../hooks";
import LaunchingSoonModal from "../popup";
import { WEB_APP_URL } from "../../utils/enums/constants";

const navItems = [
  { id: "home", label: "Home", link: "" },
  { id: "families", label: "Families", link: "families" },
  { id: "business", label: "Businesses", link: "business" },
  { id: "volunteers", label: "Volunteers", link: "volunteers" },
  { id: "contact", label: "Contact us", link: "contact" },
  {
    id: "explore",
    label: "Explore",
    children: [
      { id: "about", label: "About us", link: "exploreApp" },
      { id: "social", label: "Social Impact", link: "cards" },

      { id: "sponsor", label: "Partners", link: "sponsor" },
    ],
  },
];

const MobileNav = ({ closeSideMenu, handleNavigate }) => {
  const [showModal, setShowModal] = useState(false);
  const navRef = useOutsideClick(closeSideMenu);

  return (
    <div className="fixed left-0 top-0 z-10 flex h-full min-h-screen w-full justify-end bg-black/60 md:hidden">
      <div
        ref={navRef}
        className="h-full w-[65%] bg-white px-4 py-4 overflow-y-auto"
      >
        {/* Close Icon */}
        <section className="flex justify-end">
          <AiOutlineClose
            onClick={closeSideMenu}
            className="cursor-pointer text-4xl"
          />
        </section>

        {/* Mobile Nav Items */}
        <div className="flex flex-col gap-2 text-sm text-darkText transition-all">
          {navItems.map((item, index) => (
            <SingleNavItem
              key={index}
              label={item.label}
              link={item.link}
              children={item.children}
              handleNavigate={handleNavigate}
              closeSideMenu={closeSideMenu}
            />
          ))}
        </div>


        {/* Login/Register */}
        <section className="flex flex-col items-center gap-8">
           <a
            href={`${WEB_APP_URL}/auth/login`}
            className="bg-secondaryTextary text-primaryText transition-all"
          >
            Login
          </a> 
          {/* <button
            className="bg-secondaryTextary text-primaryText transition-all"
            onClick={() => setShowModal(true)}
          >
            Login
          </button> */}
        </section>
      </div>
      <LaunchingSoonModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </div>
  );
};

export default MobileNav;
